module.exports = __webpack_public_path__ + "static/media/new-Emi-Banner.ca3f2573.jpg";